import { Controller } from "stimulus"

export default class extends Controller {
  static targets = []

  onPostError() {
    $(".ajax-error").removeClass("d-none")
  }
}
